module.exports = __webpack_public_path__ + "img/64_personal_icons.02c6398f.png";